import { dashboardSlice, callTypes } from "./dashboardSlice";
import * as requestFromServer from "./dashboardRequest";
import { swalError } from "../../../helpers/swal";
import moment from "moment";

const { actions } = dashboardSlice;

export const getAttendanceList = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(
      actions.cardFetched({ presentDays: 0, absentDays: 0, workTimeData: [] })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllAttendance(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const attendaceData = data?.data[0]?.attendances;
        const presentDays = attendaceData?.filter((item) =>
          ["WP", "P", "HP", "EO", "Le", "L-EO", "WFH", "M"].includes(
            item?.daily_status
          )
        );
        const absentDays = attendaceData?.filter(
          (item) => item?.daily_status === "A"
        );
        const lateDays = attendaceData?.filter(
          (item) => item?.daily_status === "L"
        );
        const earlyOutDays = attendaceData?.filter(
          (item) => item?.daily_status === "EO"
        );
        const workTimeData = attendaceData
          .map((item) => {
            const rawDate = item.day_is;
            const isWeekend = item.daily_status === "W";
            const isHoliday = item.daily_status === "H";

            let label = moment(item.day_is).format("DD MMM YYYY");
            if (isHoliday) {
              label = "Holiday";
            } else if (isWeekend) {
              label = "Weekend";
            }

            const total =
              moment(item.shift_end_time).diff(
                moment(item.shift_start_time),
                "minutes"
              ) / 60;

            let work = 0;
            if (item.in_time && item.out_time) {
              work =
                moment(item.out_time).diff(moment(item.in_time), "minutes") /
                60;
            }

            return {
              rawDate,
              date: label,
              work: parseFloat(work.toFixed(2)),
              total: parseFloat(total.toFixed(2)),
            };
          })
          .sort((a, b) => new Date(a.rawDate) - new Date(b.rawDate)) // sort by real date
          .map(({ rawDate, ...rest }) => rest);
        dispatch(
          actions.cardFetched({
            presentDays: presentDays?.length,
            absentDays: absentDays?.length,
            workTimeData: workTimeData,
            lateDays: lateDays?.length,
            earlyOutDays: earlyOutDays?.length,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getLastTenAttendance = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(actions.tenDaysAttendanceFetched({ lastTenDaysAtt: [] }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTenDaysAttendance(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;

        const workTimeData = data
          .sort((a, b) => new Date(a.date) - new Date(b.date))
          .map((item) => {
            return {
              date: item?.day_is,
              total_present: Number(item?.total_present),
              absentCount: Number(item?.absentCount),
              lateCount: Number(item?.lateCount),
              leaveCount: Number(item?.leaveCount),
              homeOfficeCount: Number(item?.homeOfficeCount),
            };
          });

        dispatch(
          actions.tenDaysAttendanceFetched({
            lastTenDaysAtt: workTimeData,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getCalender = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(actions.calenderFetched({ weekend: [], holiday: [] }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllAttendance(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const attendaceData = data?.data[0]?.attendances;
        const weekDays = attendaceData
          ?.filter((item) => item?.daily_status === "W")
          .map((item) => item?.day_is);
        const holiDays = attendaceData
          ?.filter((item) => item?.daily_status === "H")
          .map((item) => item?.day_is);
        dispatch(
          actions.calenderFetched({
            weekend: weekDays ?? [],
            holiday: holiDays ?? [],
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getHolidays = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(actions.holidayFetched({ holidayLists: [] }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getHolidays(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.holidayFetched({
            holidayLists: data ?? [],
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getBirthdays = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getBirthdays()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.birthdayFetched({
            birthdays: data ?? [],
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getHrCards = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getHrCards()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.hrCardFetched({
            hrPresent: data?.presentCount,
            hrAbsent: data?.absentCount,
            hrLate: data?.lateCount,
            activeEmp: data?.active_employee_count,
            official_profile_incomplete_count:
              data?.official_profile_incomplete_count,
            salary_profile_incomplete_count:
              data?.salary_profile_incomplete_count,
            separated_employee_count: data?.separated_employee_count,
            leaveCount: data?.leaveCount,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getTotalEmployee = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTotalEmployee()
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        dispatch(
          actions.totalEmployeeFetched({
            maleEmployee: data?.maleCount,
            femaleEmployee: data?.femaleCount,
            totalEmployee: Number(data?.maleCount) + Number(data?.femaleCount),
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getTodayAttendance = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(actions.todayAttendanceFetched({ workLog: {} }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllAttendance(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const attendaceData = data?.data[0]?.attendances[0];
        const payload = {
          clockIn: moment(attendaceData?.in_time).format("hh:mm:ss A"),
          clockOut: attendaceData?.out_time
            ? moment(attendaceData?.out_time).format("hh:mm:ss A")
            : null, // or "06:10:15 PM"
          totalTime: null,
        };
        dispatch(
          actions.todayAttendanceFetched({
            workLog: attendaceData?.in_time ? payload : {},
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getLeaveList = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(actions.leaveFetched({ card: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllLeaveSummery(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;
        const leaveData = data;
        // Total Applied Leaves
        const totalAppliedLeaves = leaveData.reduce(
          (total, item) => total + parseFloat(item.applied_leaves),
          0
        );
        dispatch(
          actions.leaveFetched({
            leaveApplied: totalAppliedLeaves,
            pendingApproval: response?.data?.pending_for_approval ?? 0,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getEmployeeCard = (payload) => (dispatch) => {
  if (!payload) {
    return dispatch(
      actions.cardFetched({
        presentDays: 0,
        absentDays: 0,
        lateCount: 0,
        earlyOutCount: 0,
      })
    );
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllEmployeeCard(payload)
    .then((response) => {
      if (response.data.success) {
        const { data } = response.data;

        console.log({ data });

        dispatch(
          actions.leaveFetched({
            presentDays: data?.presentCount,
            absentDays: data?.absentCount,
            lateCount: data?.lateCount,
            earlyOutCount: data?.earlyOutCount,
          })
        );
      } else {
        if (response.data.message) {
          swalError(response.data.message);
        } else {
          swalError("something went wrong");
        }
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
